export enum MapRouteBlockTypeEnum {
  GridMultiSelect = "GridMultiSelect",
  GridSingleSelect = "GridSingleSelect",
  Kanban = "Kanban",
  CardBoard = "CardBoard",
  Calendar = "Calendar",
  RideCard = "RideCard",
  RideDetailPanel = "RideDetailPanel",
  LiveMap = "LiveMap",
  Courses = "Courses",
  StationRoutes = "StationRoutes",
}
